import request from '../../untils/request';

// 获取电表单个商户同比环比数据;
export function selectMeterYearlyMonthlyData(data) {
  return request({
    url: '/statisticsAnalysis/selectMeterYearlyMonthlyData',
    method: 'get',
    params: data,
  });
}

// 获取电表所有商户同比环比数据;
export function selectMeterYearlyMonthlyDataTotal(data) {
  return request({
    url: '/statisticsAnalysis/selectMeterYearlyMonthlyDataTotal',
    method: 'get',
    params: data,
  });
}

// 获取水表单个商户同比环比数据;
export function selectWaterYearlyMonthlyData(data) {
  return request({
    url: '/statisticsAnalysis/selectWaterYearlyMonthlyData',
    method: 'get',
    params: data,
  });
}
// 获取水表所有商户同比环比数据;
export function selectWaterYearlyMonthlyDataTotal(data) {
  return request({
    url: '/statisticsAnalysis/selectWaterYearlyMonthlyDataTotal',
    method: 'get',
    params: data,
  });
}
